import { AnalyticsEvent, AnalyticsEventTemplate, EventName } from './analytics-event';

export class SearchEvent implements AnalyticsEvent {
  event: EventName = 'search';

  search_text?: string;

  constructor(template: AnalyticsEventTemplate<SearchEvent> = {}) {
    Object.assign(this, template);
  }
}
